import { constants as Label } from '../Label';
import { VARIANT_DEFAULT, ELEMENT_FIELDSET, ELEMENT_LEGEND, ELEMENT_SUBTEXT, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Fieldset',
    variants: {
        VARIANT_DEFAULT,
    },
    elements: {
        ELEMENT_FIELDSET,
        ELEMENT_LEGEND,
        ELEMENT_SUBTEXT,
    },
});
export default function getFieldset(transformer, config) {
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_LEGEND]: {
                components: {
                    [Label.NAME]: {
                        variant: Label.variants.VARIANT_FORM,
                    },
                },
            },
        },
    });
}
